export const OPERATOR_CODES = {
    PSK: 'drs_psk',
    KAUCJA_PL: 'drs_kaucja_pl',
    POLKA: 'drs_polka',
    RESELECT: 'drs_reselekt',
    ZWROTKA: 'drs_zwrotka'
}

export const OPERATOR_EP_CODE = 'OPERATOR_EP'

export const CONTRACT_STATUSES = {
    NOT_REGISTERED: 'not_registered',
    INCOMPLETE: 'incomplete',
    ACTIVE: 'active',
    ARCHIVED: 'archived'
}

export const CONTRACT_LOCATION_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    ARCHIVED: 'archived'
}

// CP ID format: # accepts a digit, * accepts a letter or digit.
export const OPERATOR_CONFIGS = {
    [OPERATOR_CODES.PSK]: {
        cpIdFormats: ['R#######-00###']
    },

    [OPERATOR_CODES.KAUCJA_PL]: {
        cpIdFormats: ['10#####-##', '10#####-#']
    },

    [OPERATOR_CODES.POLKA]: {
        cpIdFormats: ['********-****-****-****-************'],
        retailerTokenRequired: true
    }
}